import { useEffect, useMemo, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useFetch } from '../../hook/useFecth';
import useErrors from '../../hook/useErrors';
import server from '../../services/server';
import Select from 'react-select';
import useDialog from '../../hook/useDialog';
import { useConfirm } from '../../context/BootstrapConfirm';
import { Modal } from 'react-bootstrap';
import { PriceInputMasked } from '../masks/PriceInputMasked';
import { parseCurrency } from '../../helper/currency';

const STATUS_COM_ESTOQUE_BAIXADO = new Set([
    'CONTRATO_ASSINADO',
    'PRONTO_PARA_PRODUCAO',
    'EM_PRODUCAO',
    'PRODUZIDO',
    'PRONTO_PARA_ENVIO',
    'ENVIADO',
    'ENTREGUE',
    'FINALIZADO',
    'PAGO',
]);

export default function ItemPedidoModal({ data, mutate, id, item }) {
    const { setErrors, toast } = useErrors();
    const { open: show, handleClose, id: editItemId } = useDialog('product');
    const confirm = useConfirm();
    const { data: produtos, mutate: mutateProdutos } = useFetch(`produto`, { params: { select: true } });
    const [insumoContexto, setInsumoContexto] = useState(null);
    const [insumosSelecionados, setInsumosSelecionados] = useState({});

    const { data: insumos, mutate: mutateInsumos } = useFetch(`pedido/insumo`);

    const [showInsumoModal, setShowInsumoModal] = useState(false);
    const [insumoChave, setInsumoChave] = useState('');
    const [insumoValor, setInsumoValor] = useState('');
    const [submittingInsumo, setSubmittingInsumo] = useState(false);
    const [isChaveFixa, setIsChaveFixa] = useState(false);


    const { getFieldProps, errors, handleChange, isSubmitting, isValid, handleSubmit, handleBlur, touched, values, setValues, setFieldValue, resetForm } = useFormik({
        initialValues: {
            valor: '',
            valorTotal: '',
            cor: '',
            material: '',
            salto: '',
            palmilha: '',
            numeracao: '',
            detalhes: '',
            action: 'create',
            id: '',
            produtoId: '',
            qtd: '',
            nomeItem: '',

        },
        // validationSchema: Yup.object().shape({
        //     // produtoId: Yup.string().required('Informe o produto'),
        // }),
        validateOnMount: true,
        validateOnChange: true,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                setSubmitting(true);
                if (values.action === 'create') {
                    await server.post(`pedido/${data?.id}/item`, { ...values, insumosSelec });
                    toast.success('Item adicionado com sucesso.');
                };
                if (values.action == 'update') {
                    await server.put(`pedido/${data?.id}/item/${item.id}`, { ...values, insumosSelec });
                    toast.success('Item alterado com sucesso.');
                };
                if (values.action === 'delete') {
                    await server.delete(`pedido/${data?.id}/item/${item.id}`, values);
                    toast.success('Item alterado com sucesso.');
                };
                mutate();
                mutateProdutos?.();
                handleClose();
                setSubmitting(false);
                resetForm();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    const handleCloseInsumoModal = () => {
        setShowInsumoModal(false);
        setInsumoContexto(null);
        setInsumoChave('');
        setInsumoValor('');
    };

    // useEffect(() => {
    //     if (show && Boolean(item)) {
    //         setValues({
    //             ...values,
    //             ...item,
    //             qtd: item.quantidade,
    //             valor: item.valorUnitario,
    //             action: "update",
    //         }, true);
    //     } else if (show && !item) {
    //         resetForm();
    //     }
    // }, [item, show]);
  

    async function handleRemove() {
        try {
            await confirm({ message: 'Você tem certeza que está removendo?' });
            setFieldValue('action', 'delete');
            handleSubmit();
        } catch (e) { }
    }

    function handleOpenTipoInsumoModal() {
        setInsumoChave('');
        setInsumoValor('');
        setIsChaveFixa(false);
        setShowInsumoModal(true);
    }

    function handleOpenValorInsumoModal(chave) {
        setInsumoChave(chave);
        setInsumoValor('');
        setIsChaveFixa(true);
        setShowInsumoModal(true);
    }

    async function handleCadastrarInsumo(e) {
        // e?.preventDefault();
        const chave = insumoChave.trim();
        if (!chave) {
            toast.error('Informe a chave do insumo.');
            return;
        }
        if (isChaveFixa && !insumoValor.trim()) {
            toast.error('Informe o valor do insumo.');
            return;
        }
        try {
            setSubmittingInsumo(true);
            const response = await server.post(`pedido/insumo`, {
                chave,
                valor: insumoValor.trim() || undefined,
            });
            toast.success('Insumo cadastrado com sucesso.');
            await mutateInsumos?.();
            if (isChaveFixa && response?.data?.id) {
                setInsumosSelecionados(prev => ({
                    ...prev,
                    [chave]: {
                        value: response.data.id,
                        label: response.data.valor,
                        data: response.data,
                    }
                }));
            }
            setInsumoChave('');
            setInsumoValor('');
            setShowInsumoModal(false);
        } catch (error) {
            setErrors(error);
        } finally {
            setSubmittingInsumo(false);
        }
    }
    const options = produtos?.map(produto => ({
        value: produto.id,
        nome: produto.nome,
        valor: produto.valor,
        estoque: produto.estoque,
        // capacity: produto.space?.capacity,
        // space: produto.space,
        // space_id: produto.space_id,
        requires_payment: produto.requires_payment,
        type: produto.type,
    }));
    const selected = options?.find(item => item.value === values.produtoId);
    const quantidadeSolicitada = Number(String(values.qtd || 0).replace(/\./g, '').replace(',', '.')) || 0;
    const estoqueBase = Number(selected?.estoque ?? 0);
    const quantidadeAtualDoItem = values?.id && Number(item?.produtoId) === Number(selected?.value)
        ? Number(item?.quantidade || 0)
        : 0;
    const estoqueDisponivelParaItem = selected ? estoqueBase + quantidadeAtualDoItem : 0;
    const pedidoBaixaEstoque = STATUS_COM_ESTOQUE_BAIXADO.has(data?.status);
    const estoqueInsuficiente = Boolean(selected) && quantidadeSolicitada > estoqueDisponivelParaItem;
    const estoqueInsuficienteBloqueante = pedidoBaixaEstoque && estoqueInsuficiente;

    useEffect(() => {
        // Converte valores formatados (string com vírgulas) para número
        const qtd = parseFloat(String(values.qtd || 1).replace(/\./g, '').replace(',', '.')) || 0;
        const valor = parseCurrency(values.valor) || 0;
        const total = qtd * valor;

        if (!isNaN(total) && total >= 0) {
            setFieldValue('valorTotal', total, false);
        }
    }, [values.qtd, values.valor, setFieldValue]);

    

    // const itemInsumo = (chave) => {
    //     return insumos?.itens?.filter(i => i.chave === chave) || [];
    //   };

    const insumosPorChave = useMemo(() => {
        const map = {};

        insumos?.itens?.forEach(i => {
            if (!map[i.chave]) {
                map[i.chave] = [];
            }
            map[i.chave].push(i);
        });

        return map;
    }, [insumos]);

    const insumosSelec= Object.fromEntries(
        Object.entries(insumosSelecionados).map(([chave, option]) => [
            chave,
            option?.data || null
        ])
    );


    const tipoLinhas = useMemo(() => {
        const chaves = new Map();
        (insumos?.tipo || []).forEach((t) => {
            if (t?.chave) chaves.set(t.chave, { chave: t.chave });
        });
        (item?.composicaoItemPedidos || []).forEach((row) => {
            const c = row.insumo?.chave;
            if (c && !chaves.has(c)) chaves.set(c, { chave: c });
        });
        return Array.from(chaves.values());
    }, [insumos?.tipo, item]);

    const optionsPorChave = useMemo(() => {
        const map = {};

        Object.entries(insumosPorChave || {}).forEach(([chave, itens]) => {
            map[chave] = itens.map((row) => ({
                value: row.id,
                label: row.valor,
                data: row,
            }));
        });

        (item?.composicaoItemPedidos || []).forEach((row) => {
            const ins = row.insumo;
            if (!ins?.chave) return;
            const opt = {
                value: ins.id,
                label: ins.valor || '-',
                data: ins,
            };
            if (!map[ins.chave]) map[ins.chave] = [];
            if (!map[ins.chave].some((o) => Number(o.value) === Number(ins.id))) {
                map[ins.chave].push(opt);
            }
        });

        return map;
    }, [insumosPorChave, item]);

    useEffect(() => {
        if (!show) return;

        if (item) {
            setValues({
                ...item,
                qtd: item.quantidade,
                valor: item.valorUnitario,
                action: "update",
            }, true);
        } else if (!editItemId) {
            resetForm();
            setInsumosSelecionados({});
        }
    }, [show, item, editItemId]);

    useEffect(() => {
        if (!show || !item?.composicaoItemPedidos?.length) return;

        setInsumosSelecionados(prev => {
            if (Object.keys(prev).length > 0) return prev;

            const selecionados = {};

            item.composicaoItemPedidos.forEach((row) => {
                const insumo = row.insumo;
                const insumoId = insumo?.id ?? row.insumoId;
                if (!insumoId) return;

                let chave = insumo?.chave;
                if (!chave && insumos?.itens?.length) {
                    const found = insumos.itens.find((i) => Number(i.id) === Number(insumoId));
                    chave = found?.chave;
                }
                if (!chave) return;

                const option = optionsPorChave[chave]?.find(
                    (opt) => Number(opt.value) === Number(insumoId)
                );

                if (option) {
                    selecionados[chave] = option;
                }
            });

            return Object.keys(selecionados).length ? selecionados : prev;
        });
    }, [show, item, insumos, optionsPorChave]);

    return (
        <>
            <Modal size='lg' show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-md">{values?.id ? 'Editando item' : 'Inserindo item'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="row">

                            <div className="mb-20 col-xxl-12 col-xl-8 col-md-12 col-sm-12">
                                <label htmlFor="produtoId" className="form-label">
                                    Selecione o produto
                                </label>
                                <Select
                                    id="produtoId"
                                    options={options || []}
                                    value={selected}
                                    onChange={selectable => {
                                        setFieldValue('produtoId', selectable.value);
                                        setFieldValue('product', selectable);
                                        setFieldValue('valor', selectable.valor)
                                    }}
                                    onBlur={handleBlur}
                                    className={`basic-single ${touched.produtoId && errors.produtoId ? 'is-invalid' : ''}`}
                                    classNamePrefix="select"
                                    placeholder="Selecione o produto "
                                    noOptionsMessage={() => 'Nenhuma empresa encontrada'}
                                    isDisabled={Boolean(values.id)}
                                    formatOptionLabel={(option) => (
                                        <div className='d-flex justify-content-between ' >
                                            <span>{option.nome}</span>
                                            <small className="ms-2 text-secondary">
                                                Estoque: {option.estoque ?? 0}
                                            </small>
                                        </div>
                                    )}
                                />
                                {touched.produtoId && errors.produtoId && (
                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                        {errors.produtoId}
                                    </div>
                                )}
                                {selected && (
                                    <small className="text-secondary-light d-block mt-1">
                                        Estoque disponível para este item: {estoqueDisponivelParaItem}
                                    </small>
                                )}
                                {selected && !pedidoBaixaEstoque && (
                                    <small className="text-warning d-block mt-1">
                                        Pedido em aberto: o item sera salvo sem baixar estoque. A baixa sera validada quando a venda for confirmada.
                                    </small>
                                )}
                            </div>
                            <div className="mb-20 col-xxl-6 col-xl-4 col-md-12 col-sm-12">
                                <label htmlFor="qtd" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Quantidade
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.qtd && errors.qtd && <span className="text-danger-600">{errors.qtd}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="qtd" placeholder="Quantidade" {...getFieldProps('qtd')} />
                                {estoqueInsuficiente && (
                                    <small className={`${pedidoBaixaEstoque ? 'text-danger-600' : 'text-warning'} d-block mt-1`}>
                                        Quantidade maior que o estoque disponível.
                                    </small>
                                )}
                            </div>
                            <div className="mb-20 col-xxl-6 col-xl-6 col-md-12 col-sm-12">
                                <label className="form-label text-neutral-900 fw-bold" htmlFor="valor">
                                    Valor
                                </label>
                                <PriceInputMasked
                                    {...getFieldProps('valor')}
                                    className="form-control border border-neutral-200 radius-8"
                                    id="valor"
                                    placeholder="Ex: R$ 1.500,00"
                                />
                                {touched.valor && errors.valor && <div className="invalid-feedback d-block">{errors.valor}</div>}
                            </div> <div className="mb-20 col-xxl-3 col-xl-6 col-md-12 col-sm-12">
                                <label className="form-label text-neutral-900 fw-bold" htmlFor="valorTotal">
                                    Valor Total
                                </label>
                                <PriceInputMasked
                                    {...getFieldProps('valorTotal')}
                                    readOnly
                                    disabled
                                    className="form-control border border-neutral-200 radius-8 bg-light"
                                    id="valorTotal"
                                    placeholder="Calculado automaticamente"
                                />
                                {touched.valorTotal && errors.valorTotal && <div className="invalid-feedback d-block">{errors.valorTotal}</div>}
                            </div>


                            <div className="col-12 mb-16">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 border-top border-bottom py-3">
                                    <div>
                                        <h6 className="mb-1 text-neutral-900">Insumos do item</h6>
                                        <p className="mb-0 text-secondary-light text-sm">
                                            Selecione os materiais, cores e acabamentos usados neste item.
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={handleOpenTipoInsumoModal}
                                        className="btn btn-light border border-neutral-300 text-sm px-3 py-2 radius-8 d-inline-flex align-items-center gap-1"
                                        disabled={isSubmitting || !isValid}
                                    >
                                        <i className="ri-add-line" />
                                        Novo tipo
                                    </button>
                                </div>
                            </div>

                            {tipoLinhas.length === 0 ? (
                                <div className="col-12 mb-20">
                                    <div className="border border-dashed border-neutral-300 radius-8 p-3 text-center bg-light">
                                        <p className="mb-2 text-neutral-900 fw-semibold">Nenhum tipo de insumo cadastrado.</p>
                                        <button
                                            type="button"
                                            onClick={handleOpenTipoInsumoModal}
                                            className="btn btn-primary text-sm px-3 py-2 radius-8"
                                            disabled={isSubmitting || !isValid}
                                        >
                                            Criar primeiro tipo
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="col-12 mb-20">
                                    <div className="table-responsive border radius-8">
                                        <table className="table table-sm align-middle mb-0">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th className="text-sm text-secondary fw-semibold px-3 py-2" style={{ width: '28%' }}>Tipo</th>
                                                    <th className="text-sm text-secondary fw-semibold px-3 py-2">Valor selecionado</th>
                                                    <th className="text-sm text-secondary fw-semibold px-3 py-2 text-end" style={{ width: '160px' }}>Ação</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tipoLinhas.map((i) => (
                                                    <tr key={i.chave}>
                                                        <td className="px-3 py-2 fw-semibold text-neutral-900">{i.chave}</td>
                                                        <td className="px-3 py-2" style={{ minWidth: 240 }}>
                                                            <Select
                                                                options={optionsPorChave[i.chave] || []}
                                                                placeholder="Selecione o valor"
                                                                isSearchable
                                                                classNamePrefix="select"
                                                                noOptionsMessage={() => 'Nenhum valor cadastrado'}
                                                                value={insumosSelecionados[i.chave] || null}
                                                                onChange={(selected) => {
                                                                    setInsumosSelecionados(prev => ({
                                                                        ...prev,
                                                                        [i.chave]: selected || null
                                                                    }));
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="px-3 py-2 text-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary text-sm px-3 py-2 radius-8 d-inline-flex align-items-center gap-1"
                                                                onClick={() => handleOpenValorInsumoModal(i.chave)}
                                                            >
                                                                <i className="ri-add-line" />
                                                                Novo valor
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {/* <div className="mb-20 col-xxl-6 col-xl-6 col-md-12 col-sm-12">
                                <label htmlFor="material" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Material
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.material && errors.material && <span className="text-danger-600">{errors.material}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="material" placeholder="Material usado na produção" {...getFieldProps('material')} />
                            </div>
                            <div className="mb-20 col-xxl-6 col-xl-6 col-md-12 col-sm-12">
                                <label htmlFor="salto" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Salto
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.salto && errors.salto && <span className="text-danger-600">{errors.salto}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="salto" placeholder="Tipo de salto" {...getFieldProps('salto')} />
                            </div>
                            <div className="mb-20 col-xxl-6 col-xl-6 col-md-12 col-sm-12">
                                <label htmlFor="palmilha" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Palmilha
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.palmilha && errors.palmilha && <span className="text-danger-600">{errors.palmilha}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="palmilha" placeholder="Palmilha da produção" {...getFieldProps('palmilha')} />
                            </div>
                            <div className="mb-20 col-xxl-6 col-xl-6 col-md-12 col-sm-12">
                                <label htmlFor="cor" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Cor
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.cor && errors.cor && <span className="text-danger-600">{errors.cor}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="cor" placeholder="cor da produção" {...getFieldProps('cor')} />
                            </div>
                            <div className="mb-20 col-xxl-6 col-xl-6 col-md-12 col-sm-12">
                                <label htmlFor="numeracao" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                    Numeração
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.numeracao && errors.numeracao && <span className="text-danger-600">{errors.numeracao}</span>}
                                </label>
                                <input type="text" className="form-control radius-8" id="numeracao" placeholder="Numeração" {...getFieldProps('numeracao')} />
                            </div> */}
                            <div className="mb-20 col-xxl-12 col-xl-12 col-md-12 col-sm-12">
                                <label
                                    htmlFor="detalhes"
                                    className="form-label text-primary-light text-sm fw-semibold mb-8"
                                >
                                    Detalhes
                                    <span className="text-danger-600">*</span>{' '}
                                    {touched.detalhes && errors.detalhes && (
                                        <span className="text-danger-600">{errors.detalhes}</span>
                                    )}
                                </label>
                                <textarea
                                    className="form-control radius-8"
                                    id="detalhes"
                                    placeholder="Quantidade no estoque"
                                    rows={3} // ajusta a altura inicial
                                    {...getFieldProps('detalhes')}
                                />
                            </div>


                            <div className="d-flex   align-items-cent justify-content-end gap-3 mt-10">
                                {values?.id && (
                                    <button
                                        type="button"
                                        onClick={handleRemove}
                                        className="btn btn-danger  border border-primary-600 text-md px-3 py-2 radius-8"
                                        disabled={isSubmitting || !isValid}
                                    >
                                        <i className=" ri-delete-bin-line" />

                                        {isSubmitting ? 'Excluindo...' : 'Excluir'}
                                    </button>
                                )}
                                <button
                                    type="submit"
                                    className="btn btn btn-primary border border-primary-600 text-md px-3 py-2 radius-8"
                                    disabled={isSubmitting || estoqueInsuficienteBloqueante}
                                >
                                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                                </button>

                            </div>
                        </div>

                    </form>
                </Modal.Body>

            </Modal >

            <InsumoModal
                onHide={() => !submittingInsumo && setShowInsumoModal(false)}
                show={showInsumoModal}
                onClose={handleCloseInsumoModal}
                onSubmit={handleCadastrarInsumo}
                submitting={submittingInsumo}
                insumoChave={insumoChave}
                setInsumoChave={setInsumoChave}
                insumoValor={insumoValor}
                setInsumoValor={setInsumoValor}
                selectedNome={selected?.nome || values?.product?.nome}
                isChaveFixa={isChaveFixa}

            />

            {/* <Modal show={showInsumoModal} onHide={() => !submittingInsumo && setShowInsumoModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-md">Cadastrar insumo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-secondary mb-16">
                        O insumo será vinculado ao item:{' '}
                        <strong>{selected?.nome || values?.product?.nome || 'este item'}</strong>
                    </p>
                    <form id="form-insumo-item" onSubmit={handleCadastrarInsumo}>
                        <div className="mb-16">
                            <label htmlFor="insumo-chave" className="form-label">
                                Chave <span className="text-danger-600">*</span>
                            </label>
                            <input
                                id="insumo-chave"
                                type="text"
                                className="form-control radius-8"
                                value={insumoChave}
                                onChange={e => setInsumoChave(e.target.value)}
                                placeholder="Identificação do insumo"
                                autoComplete="off"
                            />
                        </div>
                        <div className="mb-0">
                            <label htmlFor="insumo-valor" className="form-label">
                                Valor (opcional)
                            </label>
                            <input
                                id="insumo-valor"
                                type="text"
                                className="form-control radius-8"
                                value={insumoValor}
                                onChange={e => setInsumoValor(e.target.value)}
                                placeholder="Observação ou valor em texto"
                                autoComplete="off"
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-light border radius-8"
                        disabled={submittingInsumo}
                        onClick={() => setShowInsumoModal(false)}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        form="form-insumo-item"
                        className="btn btn-primary radius-8"
                        disabled={submittingInsumo}
                    >
                        {submittingInsumo ? 'Salvando...' : 'Cadastrar'}
                    </button>
                </Modal.Footer>
            </Modal> */}
        </>
    )
}



export const InsumoModal = ({
    show,
    onClose,
    onSubmit,
    submitting,
    insumoChave,
    setInsumoChave,
    insumoValor,
    setInsumoValor,
    selectedNome,
    isChaveFixa
}) => {
    return (
        <Modal show={show} onHide={() => !submitting && onClose()} centered>
            <Modal.Header closeButton>
                <Modal.Title className="text-md">
                    {isChaveFixa ? 'Novo valor de insumo' : 'Novo tipo de insumo'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="text-secondary mb-16">
                    {isChaveFixa
                        ? <>Cadastre uma nova opção para <strong>{insumoChave}</strong>.</>
                        : 'Crie uma nova categoria para organizar os insumos do item.'}
                </p>
                <form id="form-insumo-item" onSubmit={onSubmit}>
                    <div className="mb-16">
                        <label className="form-label">
                            Tipo <span className="text-danger-600">*</span>
                        </label>
                        <input
                            disabled={isChaveFixa}
                            type="text"
                            className="form-control radius-8"
                            value={insumoChave}
                            onChange={e => setInsumoChave(e.target.value)}
                            // onChange={e => setInse.target.valueumoChave()}
                            placeholder="Ex: Material, Cor, Acabamento"
                        />
                    </div>

                    {isChaveFixa && (
                        <>

                            <div>
                                <label className="form-label">
                                    Valor <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control radius-8"
                                    value={insumoValor}
                                    onChange={e => setInsumoValor(e.target.value)}
                                    placeholder="Ex: Couro, Preto, Fosco"
                                />
                            </div>
                        </>
                    )}

                </form>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-light border radius-8"
                    disabled={submitting}
                    onClick={onClose}
                >
                    Cancelar
                </button>

                <button
                    type="submit"
                    form="form-insumo-item"
                    className="btn btn-primary radius-8"
                    disabled={submitting}
                >
                    {submitting ? 'Salvando...' : isChaveFixa ? 'Cadastrar valor' : 'Cadastrar tipo'}
                </button>
            </Modal.Footer>
        </Modal>
    );
};


